import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../lib/Errors';

let localSubscription = undefined;

function createSubscription(store) {
	let dataQuery = new Parse.Query('MedicationUnit');
	dataQuery.notEqualTo("deleted", true)
	dataQuery.addAscending("name")
	dataQuery.find()
		.then((results) => {
			store.dispatch('medicationUnit/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
		dataQuery.subscribe().then((subscription) => {
		
		localSubscription = subscription;

		subscription.on('create', object => {
			
			store.dispatch('medicationUnit/insert', object)
		});
		subscription.on('update', object => {
			
			store.dispatch('medicationUnit/replace', object)
		});
		subscription.on('enter', object => {
			
			store.dispatch('medicationUnit/insert', object)
		});
		subscription.on('leave', object => {
			
			store.dispatch('medicationUnit/delete', object)
		});
		subscription.on('delete', object => {
			
			store.dispatch('medicationUnit/delete', object)
		});
		subscription.on('close', () => {
		});
		subscription.on('error', error => {
            console.log('MedicationUnit subscription error', error);
        })
	})
}

export default function createMedicationUnitSubscription() {
	return store => {
		if (store.state.currentUser) {
			createSubscription(store)
		}
		store.subscribe(mutation => {
			if (mutation.type === 'SET_CURRENT_USER') {
				if (localSubscription) {
					localSubscription.unsubscribe()
				}
				if (store.state.currentUser) {
					createSubscription(store)
				}
			}
		})
	}
}
